import { useEffect, useState } from "react";
import { navItems } from "@/mocks/homeData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeId, setActiveId] = useState(navItems[0].id);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
      const current = navItems
        .map((item) => {
          const el = document.getElementById(item.id);
          return { id: item.id, top: el ? el.getBoundingClientRect().top : Number.MAX_SAFE_INTEGER };
        })
        .filter((item) => item.top <= 140)
        .pop();
      if (current) setActiveId(current.id);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? "border-b border-background-200/80 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between px-4 md:h-20 md:px-8">
        <a href="#top" className="flex items-center gap-3">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg md:h-10 md:w-10 ${
              solid ? "bg-primary-500" : "bg-primary-500"
            }`}
          >
            <i className="ri-movie-2-line text-lg text-background-50 md:text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-bold md:text-xl ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              韩剧TV
            </span>
            <span
              className={`mt-0.5 text-[10px] font-medium tracking-wide md:text-xs ${
                solid ? "text-foreground-500" : "text-background-50/70"
              }`}
            >
              下载 · 缓存 · 离线观看
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`rounded-md px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                activeId === item.id
                  ? solid
                    ? "bg-primary-100 text-primary-700"
                    : "bg-background-50/20 text-background-50"
                  : solid
                    ? "text-foreground-600 hover:text-foreground-950"
                    : "text-background-50/80 hover:text-background-50"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#install"
            className="hidden items-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-download-2-line text-base"></i>
            <span className="whitespace-nowrap">下载安装</span>
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
            className={`flex h-10 w-10 items-center justify-center rounded-md border md:hidden ${
              solid
                ? "border-background-300 text-foreground-800"
                : "border-background-50/40 text-background-50"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className={`rounded-md border px-3 py-2.5 text-sm font-medium whitespace-nowrap ${
                  activeId === item.id
                    ? "border-primary-300 bg-primary-100 text-primary-700"
                    : "border-background-200 bg-background-100 text-foreground-700"
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>
          <a
            href="#install"
            onClick={() => setMenuOpen(false)}
            className="mt-2 flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
          >
            <i className="ri-download-2-line text-base"></i>
            开始下载安装
          </a>
        </div>
      ) : null}
    </header>
  );
}